import { render } from "./TvmNavigateToInventory.vue?vue&type=template&id=5791ab68&scoped=true"
import script from "./TvmNavigateToInventory.js?vue&type=script&lang=js&external"
export * from "./TvmNavigateToInventory.js?vue&type=script&lang=js&external"

import "./TvmNavigateToInventory.vue?vue&type=style&index=0&id=5791ab68&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5791ab68"],['__file',"src/Components/ChatWidget/TvmNavigateToInventory/TvmNavigateToInventory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5791ab68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5791ab68', __exports__)) {
    api.reload('5791ab68', __exports__)
  }
  
  module.hot.accept("./TvmNavigateToInventory.vue?vue&type=template&id=5791ab68&scoped=true", () => {
    api.rerender('5791ab68', render)
  })

}


export default __exports__